import {Injectable} from '@angular/core';
import {PortfolioService} from '../../service/portfolio.service';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {PortfolioCreationData} from '../../model/portfolio-creation-data/portfolio-creation-data.model';

@Injectable()
export class PortfolioCreationDataResolver implements Resolve<PortfolioCreationData> {
    private readonly portfolioService: PortfolioService;

    constructor(portfolioService: PortfolioService) {
        this.portfolioService = portfolioService;
    }

    public async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PortfolioCreationData> {
        const tempPortfolioId = route.params.tempPortfolioId;
        return await this.portfolioService.getLocalPortfolioCreationData(tempPortfolioId);
    }
}